import styled from '@emotion/styled';
import { css } from '@emotion/core';
import { TextSpan, truncateCss } from 'app/typography';
import { layers } from 'app/spacing';

export const StyledLabel = styled.label`
  display: inline-flex;
  align-items: center;
  margin: ${({ size }) => (size === 'small' ? `10px 10px 10px 0` : '12px')};
  user-select: none;
  overflow: hidden;
`;

export const StyledInput = styled.input`
  position: absolute;
  opacity: 0;
  z-index: ${layers.content(0)};
`;

export const StyledInputFacade = styled.span`
  position: relative;
  // 13px = 12px plus a 1px border
  width: ${({ size }) => (size === 'small' ? '14px' : '16px')};
  height: ${({ size }) => (size === 'small' ? '14px' : '16px')};
  border: 1px solid var(--color-border-dark);
  border-radius: 50%;
  z-index: ${layers.content(0, 1)};

  ${StyledLabel}:hover & {
    border-color: ${(props) =>
      props.error
        ? 'var(--color-button-warning-hover)'
        : 'var(--color-button-secondary-hover)'};
  }

  ${StyledInput}:checked~& {
    &::after {
      content: '';
      position: absolute;
      left: 50%;
      top: 50%;
      width: 10px;
      height: 10px;
      background: var(--color-button-secondary-hover);
      border-radius: 50%;
      transform: translate(-50%, -50%);
    }
  }

  ${StyledInput}:disabled~& {
    border-color: var(--color-border-dark);
  }

  ${StyledInput}:disabled:checked~& {
    &::after {
      background: var(--color-background-dark);
    }
  }

  ${(props) =>
    props.error &&
    css`
      border-color: var(--color-button-warning-hover);
    `}
`;

export const StyledText = styled(TextSpan)`
  margin-left: 10px;
  flex: 1;
  ${truncateCss}
  color: ${(props) =>
    props.disabled
      ? 'var(--color-font-placeholder)'
      : 'var(--color-font-primary)'};
`;
